export const getDifferenceInDays = (date1: Date, date2: Date) => {
    const diffTime =date2.getTime() - date1.getTime();
    return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
}